import * as React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import TopBar from "../../components/TopBarV2";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import {useIntl} from 'react-intl'
import Button from "@mui/material/Button/Button";
import Avatar from "@mui/material/Avatar/Avatar";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Switch from "@mui/material/Switch/Switch";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Badge from "@mui/material/Badge/Badge";
import Step from "@mui/material/Step/Step";
import StepLabel from "@mui/material/StepLabel/StepLabel";
import { styled } from '@mui/material/styles';
import WorkHistoryScreen from "../../components/WorkHistory";
import InterestsComponent from "../../components/interests";
import ActivitiesComponent from "../../components/activities";
import {AuthUserContext} from "../../providers/AuthProvider";
import firebase from '../../firebase/firebase'
import WorkHistory from "../common/profile-setup/work-history";

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import moment from 'moment';
import Portfolio from "../common/profile-setup/portfolio";
import AddProject from "../creator/add-project";
import EditProjectProtofolio from "../creator/edit-portofolio-project";
import PortfolioProjectDetail from "../creator/portfolioProjectDetail";
import AddProjectArtists from "../artist/add-project-artists";
import ScrollToTop from '../../utils/scrollTop';
import { AddAPhoto, AddAPhotoOutlined, AddPhotoAlternate, CheckCircle, Edit } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
export default function InvestorProfile() {
   
  const [checked, setChecked] = React.useState();
  const [publicData, setPublic] = React.useState()
  const [view, setView] = React.useState('self');
  const handleChange = (event) => {
    const usersRef = firebase.firestore().collection('users');
    setChecked(event.target.checked);
    usersRef.doc(profile.id).update({openToInvest: event.target.checked}).then()
  };
  const [project, setProject] = React.useState()
  const { user, profile, setUser, setProfile   } = React.useContext(AuthUserContext);
  const [profileImage, setProfileImage] = React.useState();
  const [geographyTags, setGeography] = React.useState([])
  const [addProjectView, setAddProjectView] = React.useState([])
  const [editProjectView, setEditProjectView] = React.useState(false)
  const [detailProjectView, setDetailProjectView] = React.useState(false)
  const [artistAddProject, setArtistAddProject] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [editing, setEditing] = React.useState(false)
  const Input = styled('input')({
    display: 'none',
  })
   
  const {messages} = useIntl()
  const steps = ['Create Profile', 'Apply for Investor Status', 'Set Interests', 'View Projects'];

  const [activeTab, setTab] = React.useState('work history');
  React.useEffect(() => {
    const refGeographiesTags = firebase.firestore().collection('userGeographies');
    if (profile) {
      setChecked(profile?.openToInvest || false)
      refGeographiesTags
        .where('uid', '==',profile.uid)
        .get()
        .then(data => {
          if (data && data.docs.length) {
            setGeography(data.docs[0].data().tags)
          }
        })
    }
  }, [profile]);
   React.useEffect( () => {
    // if (mode === 'public') {
    //  loadProfile();

  }, [])
  const callbackFunction = (next) => {
      
    setTab(next)
  }
  const portfolioCallback = (bool) => {
    setAddProjectView(bool)
    if (bool === false) {
      // setTab('activities')
    }

  }
  const projectEditCallback = (bool, index, project, type) => {
     if(type === 'edit') {
       setEditProjectView(bool)
       setDetailProjectView(!bool)

     } else {
       if (type) {
         setDetailProjectView(bool)
         setEditProjectView(!bool)
       } else {
         setDetailProjectView(false)
         setEditProjectView(false)
       }

     }

    setProject({...project, index})
  }
  const loadProfile = async ()=>{
    const profilesRef = firebase.firestore().collection('profiles');
    const profile = await profilesRef.where('uid', '==', user.uid)
      .get()
      .then()
    const projects = [];
    const  experiences = [];
    const publicProfile = {...profile.docs[0].data(), id: profile.docs[0].id}
    const projectsSnap = await profilesRef
      .doc(profile.docs[0].id)
      .collection('projects')
      .get()
      .then()
    if (projectsSnap && projectsSnap.docs.length > 0) {
      projectsSnap.docs.forEach(d => {
        projects.push({id: d.id, ...d.data()})
      })
    }
    const expSnap = await profilesRef
      .doc(profile.docs[0].id)
      .collection('experiences')
      .get()
      .then()
    if (expSnap && expSnap.docs.length > 0) {
      expSnap.docs.forEach(d => {
        experiences.push({id: d.id, ...d.data()})
      })
    }
    setPublic({...publicProfile, experiences, projects})
    // }
    // console.log('profileData: ',JSON.stringify(publicData) )
  }

  const storageRef = firebase.storage().ref();
  
  const downloadURL = (url) =>
		new Promise((resolve, reject) => {
			const mediaRef = storageRef.child(url);

			// Get the download URL
			mediaRef
				.getDownloadURL()
				.then((url) => {
					resolve(url);
				})
				.catch((error) => {
					resolve('error');
					// setLoading(false)

					// A full list of error codes is available at
					// https://firebase.google.com/docs/storage/web/handle-errors
					switch (error.code) {
						case "storage/object-not-found":
							// File doesn't exist
							break;
						case "storage/unauthorized":
							// User doesn't have permission to access the object
							break;
						case "storage/canceled":
							// User canceled the upload
							break;

						// ...

						case "storage/unknown":
							// Unknown error occurred, inspect the server response
							break;
					}
				});
		});
    
  let path
  const uploadFile =  () => new Promise((resolve, reject) => {
    setLoading(true)

    const file = profileImage?.file
    path = `profile-image/${file.name}`
    const uploadTask = storageRef.child(path).put(file);

    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        console.log(profileImage)
        const image = {...profileImage, progress}
        setProfileImage(image)
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
        setLoading(false)

      },
      () => {
        resolve()
        setProfile({...profile, avatar: profileImage?.src})

        setLoading(false)
        setProfileImage(null)

      }

    );  })
  const updatePFP = async () =>{
    await uploadFile()
    const usersRef = firebase.firestore().collection('users').doc(profile.id);
    await downloadURL(path).then((url)=>{
      setProfile({...profile, avatar: url})
      usersRef.update({avatar: path})
      setEditing(false)
      // setProfileImage(null)
      // usersRef.get().then((doc)=>{console.log(doc.data())})
      // console.log(profile)
      // console.log('profile picture update function')
      
    })
    // console.log(avatar)
  }
  
  
  return (
    <>
    <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }}/>
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      {addProjectView === true ?
        <AddProject parentcallback={portfolioCallback}/> :
        editProjectView === true ? <EditProjectProtofolio parentcallback={projectEditCallback} data={project} /> :
          detailProjectView === true ? <PortfolioProjectDetail parentcallback={projectEditCallback} data={project} /> :
            <>
          <Container maxWidth="lg" component="main" sx={{my: 12}}>
            <Grid container spacing={2} >

              <Grid item xs={12}  md={4} sx={{
              }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'start',
                    mb: 2,
                    pb:2,
                    flexDirection:'column',
                    height: 150,
                  }}
                >
                  <Stack direction="row"
                         justifyContent="flex-start"
                         alignItems="center"
                         spacing={5} sx={{height: 150}}>
                     <Stack direction={'column'} spacing={2} width={200} justifyContent='center' alignItems='center'>
                    { profile && profileImage ? 
                    <label htmlFor='profile-image'>
                    <div>
                    {editing && 
                       <div className='edit-overlay' style={{borderRadius:"100%"}}>
                          <AddAPhotoOutlined className='edit-media' fontSize='large' sx={{color:"#FFFFFF"}}/>
                        </div>
                    }
                    <Avatar src={profileImage.src}  sx={{width: 150, height: 150, border: '1px solid #fff'}}/>
                    </div>

                    <Input accept="image/*" id="profile-image" multiple={false} type="file" onChange={(e)=>{
                      setEditing(true);
                      const fileReader = new FileReader();
                      fileReader.readAsDataURL(e.target.files[0]);
                      fileReader.addEventListener("load", async function () {
                        setProfileImage({
                          progress:0,
                          src: this.result,
                          file: e.target.files[0],
                          size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)
                        });
                      });
                    }} 
                    />

                    </label>
                    :
                      profile && profile?.avatar ?
                      <div>
                       {/* {editing && 
                       <div className='edit-overlay' style={{borderRadius:"100%"}}>
                          <AddAPhotoOutlined className='edit-media' fontSize='large' sx={{color:"#FFFFFF"}}/>
                        </div>} */}
                        <Avatar alt="Remy Sharp" src={profile?.avatar}  sx={{width: 150, height: 150, border: '1px solid #fff' }} />

                      </div> 
                      :
                      <Avatar alt={profile && profile?.name ? profile?.name  : ''} sx={{width: 150, height: 150, border: '1px solid #fff', fontSize: 'xxx-large', textTransform:'uppercase', backgroundColor: '#204488'}}>
                          { profile?.name.charAt(0)}
                        </Avatar>
                    } 
                  
                     
                    {editing ?
                    <div style={{display:"flex", flexDirection:"column"}}>
                    <Button variant={'outlined'}  sx={{paddingX: 4, textTransform:"none", mb:2, mt:1}} component="span" onClick={updatePFP} disabled={!profileImage}>Upload {profileImage?.progress === 100 && <CheckCircle style={{marginLeft: '15px'}}/>} {loading && <CircularProgress sx={{ml: 2}} size={20} color="primary"/>}</Button>
                    <Button variant='text' onClick={() => {setProfileImage(undefined); setEditing(false)}} 
                    // disabled={!(profileImage && profileImage?.src)}
                    >
                      Cancel</Button>
                    </div>
                    :
                    <>
                      <label htmlFor="profile-image">
                     <Button variant={'outlined'}  sx={{paddingX: 4, textTransform:"none", mt:1}} component="span">Edit Picture</Button>
                     <Input accept="image/*" id="profile-image" multiple={false} type="file" onChange={(e)=>{
                       setEditing(true);
                       const fileReader = new FileReader();
                       fileReader.readAsDataURL(e.target.files[0]);
                       fileReader.addEventListener("load", async function () {
                         setProfileImage({
                           progress:0,
                           src: this.result,
                           file: e.target.files[0],
                           size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)
                           
                           
                          });
                        });
                      }} 
                      />
                    </label>
                      <Button variant='text' sx={{textDecoration:"underline"}} 
                      onClick={() => 
                       { setProfileImage(null);
                         const usersRef = firebase.firestore().collection('users').doc(profile.id);
                         setProfile({...profile, avatar: null})
                         usersRef.update({avatar: null})
                       }}
                       disabled={!(profile?.avatar)}>Remove picture</Button>
                    </>
                    }
                    </Stack>     
                    {/* <Stack direction="column"  justifyContent="flex-start"
                           alignItems="flex-start" sx={{textAlign:'left'}} spacing={2}>
                      <Typography variant="body2" sx={{textTransform: 'Capitalize'}}>
                        {profile?.userType}
                      </Typography>

                      <Typography variant="h4" color={'primary'} sx={{textTransform: 'Capitalize'}}>
                        {profile?.name}
                      </Typography>
                    </Stack> */}
                    <Stack direction="row"  spacing={20} >
                    <Stack direction="column" style={{width:"200px"}} >
                    <Box style={{width:"200px",textAlign:"left"}}>
                    <Typography variant="body2"  sx={{textTransform: 'Capitalize'}}>
                        {profile?.userType}
                      </Typography>
                      <Typography variant="h5"  color={'primary'} sx={{textTransform: 'Capitalize'}}>
                        {profile?.name}
                      </Typography>
                      </Box>
                      </Stack>
                      <Stack direction="column" >
                      <Typography variant="body2" style={{width:"200px"}} sx={{textTransform: 'Capitalize'}}>
                      Location
                    </Typography>
                    <Typography variant="h5" style={{width:"200px",marginLeft:"45px"}} color={'primary'} sx={{textTransform: 'Capitalize'}}>
                      United States
                    </Typography>
                    </Stack>
                    <Stack direction="column" style={{width:"200px"}}>
                    <br>
                    </br>
                    
                    <Typography variant={'body2'} color={'primary'}>
                      <Badge color="primary" variant="dot" /> &nbsp;Joined: {moment(profile?.createdAt.seconds*1000).format('MMM Do, YYYY')}

                    </Typography>
                    </Stack>
                 
                    </Stack>
                  
                  </Stack>
                  

                </Box>
              </Grid>
              <Grid item xs={12}  md={4} sx={{
              }}>
                {/* <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'end',
                    mb: 2,
                    pb:2,
                    height: 150,
                    flexDirection:'column',

                  }}
                >

                  <Stack direction="column"  justifyContent="center"
                         alignItems="flex-start" spacing={1} sx={{ height: 150}}>
                    <Typography variant="body2" sx={{textTransform: 'Capitalize'}}>
                      Location
                    </Typography>

                    <Typography variant="h4" color={'primary'} sx={{textTransform: 'Capitalize'}}>
                      United States
                    </Typography>
                  </Stack>
                </Box> */}
              </Grid>
             

                  
            
           
            </Grid>
          </Container>
          <Container maxWidth="full-width" component="main" sx={{backgroundColor: '#204488', height: 60}}>
            <Container maxWidth="lg" component="main" sx={{textAlign:'left'}}>
              <Grid  container
                     direction="row"
                     alignItems="center">
                <Grid xs={12}  md={4}   sx={{m: '10px 0px'}}>
                  <Box sx={{backgroundColor: activeTab === 'work history' ? '#fff': '#ffffff000'}}>
                    <Button sx={{width: '100%', height: 50, fontSize:'24px',
                      color: activeTab === 'work history' ? '': '#fff',
                      fontWeight:activeTab === 'work history' ? 600: ''}} onClick={() => setTab('work history')}>WORK HISTORY</Button>
                  </Box>
                </Grid>
                <Grid xs={12}  md={4}  sx={{m: '10px 0px'}}>
                  <Box sx={{backgroundColor: activeTab === 'interests' ? '#fff': '#ffffff000'}}>
                    <Button sx={{width: '100%', height: 50,  fontSize:'24px',
                      color: activeTab === 'interests' ? '': '#fff',
                      fontWeight:activeTab === 'interests' ? 600: ''}} onClick={() => setTab('interests')}>
                      {
                        profile?.userType === 'creator' || profile?.userType === 'artist'
                          ? 'PORTFOLIO' : 'INTERESTS'
                      }

                    </Button>
                  </Box>
                </Grid>
                <Grid xs={12}  md={4}  sx={{m: '10px 0px'}}>
                  <Box sx={{backgroundColor: activeTab === 'activities' ? '#fff': '#ffffff000'}}>
                    <Button sx={{width: '100%', height: 50,  fontSize:'24px',
                      color: activeTab === 'activities' ? '': '#fff',
                      fontWeight:activeTab === 'activities' ? 600: ''}} onClick={() => setTab('activities')}>ACTIVITIES</Button>
                  </Box>
                </Grid>

              </Grid>
            </Container>
          </Container>
          {
            activeTab === 'work history' ?
              <WorkHistory parentCallback = {callbackFunction}/> :
              activeTab === 'interests' && ( profile?.userType === 'creator'  || profile?.userType === 'artist' ) && artistAddProject === false
                ?  <Portfolio parentCallback = {portfolioCallback} projectEditCallback={projectEditCallback} artistAddProjectCallBack={(bool) => setArtistAddProject(bool)}/>
                : activeTab === 'interests' && profile?.userType === 'artist'  && artistAddProject === true ? <AddProjectArtists parentcallback={() => setArtistAddProject(!artistAddProject)} />:
                activeTab === 'interests' && profile?.userType === 'investor'? <InterestsComponent parentCallback={callbackFunction}/> :   <ActivitiesComponent mode={view}/>

          }
        </>
      }




    </>
  );


}